import store from '../../app/store';
import { hasSucceeded } from '../../constants/async-status';

declare global {
    interface Window {
        appData?: Array<any>;
        Org?: {
            Metrics?: {
                sc?: any;
            };
        };
        pendo?: {
            initialize: (metadata: IPendoMetaData) => void;
            updateOptions: (metadata: IPendoMetaData) => void;
        };
    }
}

export interface IPendoMetaData {
    visitor: {
        name?: string;
        pageName: string;
        id: string;
        accessType: string;
        role: string | undefined;
    };
    account: {
        id: string;
        name: string;
    };
}

interface IVisitor {
    accessType: string;
    loginStatus: string;
    accountName: string;
    userId: string;
    accountId: string;
    role?: string;
}

interface IMetrics {
    businessUnit: string;
    environment: string;
    productName: string;
    [key: string]: string;
}

let pendoMetaData: IPendoMetaData | null = null;

let visitor: IVisitor = {
    accessType: 'CLH:REG_GUEST',
    loginStatus: 'registered',
    accountName: '',
    userId: '',
    accountId: '',
    role: '',
};

const metrics: IMetrics = {
    businessUnit: 'ELS:CLH:OTR',
    environment: process.env.NODE_ENV === 'production' ? 'prod' : 'dev',
    productName: 'CLH',
};

export function initializePendo() {
    store.subscribe(() => {
        const valuesFromStore = store.getState().login;
        if (
            Object.keys(valuesFromStore).length > 0 &&
            hasSucceeded(valuesFromStore.asyncStatus)
        ) {
            const {
                userId,
                clientInfo: { organizationName },
                clientId,
                userRole: { name: role },
            } = valuesFromStore;
            visitor = {
                ...visitor,
                accountName: `CLH:${organizationName}`,
                userId: `CLH:${userId}`,
                accountId: `CLH:${clientId}`,
                role: `CLH:${role}`,
            };
        }
    });

    const wr = window as any;
    if (wr.appData !== undefined && wr.Org && wr.Org.Metrics) {
        wr.appData.push({
            event: 'pageLoad',
            page: { ...wr.Org.Metrics.sc },
            visitor: { ...visitor },
        });
    }
    if (
        wr.pendo !== undefined &&
        wr.Org &&
        wr.Org.Metrics &&
        wr.Org.Metrics.sc
    ) {
        pendoMetaData = {
            visitor: {
                id: visitor.userId,
                accessType: visitor.accessType,
                role: visitor.role,
                pageName: wr.Org.Metrics.sc.name,
                ...metrics,
            },
            account: {
                id: visitor.accountId,
                name: visitor.accountName,
            },
        };
        if (pendoMetaData && pendoMetaData.visitor) {
            delete pendoMetaData.visitor.name;
        }
        if (pendoMetaData) {
            wr.pendo.initialize(pendoMetaData);
        }
    }
}

export function sendToPendo() {
    const wr = window;
    if (wr.appData !== undefined && wr.Org && wr.Org.Metrics) {
        wr.appData.push({
            event: 'newPage',
            page: { ...wr.Org.Metrics.sc },
            visitor: { ...visitor },
        });
    }
    if (
        wr.pendo !== undefined &&
        wr.Org &&
        wr.Org.Metrics &&
        wr.Org.Metrics.sc &&
        pendoMetaData
    ) {
        if (pendoMetaData.visitor) {
            pendoMetaData.visitor.pageName = wr.Org.Metrics.sc.name;
        }
        wr.pendo.updateOptions(pendoMetaData);
    }
}

export function updateMetricsObject(deltaMetrics: Partial<IMetrics>) {
    Object.assign(metrics, deltaMetrics);
    const wr = window as any;
    wr.Org = wr.Org || {};
    wr.Org.Metrics = wr.Org.Metrics || {};
    wr.Org.Metrics.sc = metrics;
    return wr.Org.Metrics.sc;
}
